var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.238,
    height: 22.238,
    viewBox: "0 0 22.238 22.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-logo-whatsapp",
    "data-name": "Icon ionic-logo-whatsapp",
    d: "M13.571,2.25A10.875,10.875,0,0,0,2.654,13.083,10.721,10.721,0,0,0,4.22,18.676L2.25,24.488l6.044-1.92a10.936,10.936,0,0,0,16.194-9.485A10.875,10.875,0,0,0,13.571,2.25ZM19,17.2a2.82,2.82,0,0,1-1.931,1.245c-.512.027-.527.4-3.318-.816a11.39,11.39,0,0,1-4.6-4.352,5.354,5.354,0,0,1-1.03-2.9A3.093,3.093,0,0,1,9.181,8.1a1.069,1.069,0,0,1,.756-.318c.22,0,.362-.007.525,0s.407-.034.618.528.717,1.944.782,2.084a.506.506,0,0,1,.005.485,1.9,1.9,0,0,1-.3.451c-.146.156-.306.35-.436.469s-.3.277-.144.559a8.354,8.354,0,0,0,1.478,1.972,7.617,7.617,0,0,0,2.189,1.455c.274.149.437.133.607-.046s.727-.782.923-1.051.38-.217.632-.116,1.6.822,1.87.97.456.225.522.343A2.293,2.293,0,0,1,19,17.2Z",
    transform: "translate(-2.25 -2.25)",
    fill: "#3254fe"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.8315e128591984efa3c827a90576fe76.svg";
export { ForwardRef as ReactComponent };